module.exports = __webpack_public_path__ + "static/img/open-data-pa-branding-footer-logo-white.02fba3a0.png";